import { render, staticRenderFns } from "./NavigationMobile.vue?vue&type=template&id=c1979586"
import script from "./NavigationMobile.vue?vue&type=script&lang=js"
export * from "./NavigationMobile.vue?vue&type=script&lang=js"
import style0 from "./NavigationMobile.vue?vue&type=style&index=0&id=c1979586&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports